/**
 * Handling of news feature
 *  - At every page load it will fetch the unread news
 *  - It then shows news by news in a separate modal
 */

import Modal from "./modal";

const $ = require("jquery");
$(document).ready(function() {
    if (window.config.user.loggedIn) {
        getUnconfirmed();
    }
});

var myModal = [];

/**
 * Fetch the unread news and build all modals for it
 */
function getUnconfirmed() {
    window.axios.get(window.config.urls.news.unconfirmed).then(({data: data}) => {
        let newsList = data.newsList;

        newsList.forEach(function (news, index) {

            let title = news.title;
            if (newsList.length > 1) {
                title += ' (' + (index + 1) + '/' + newsList.length + ')';
            }

            myModal[index] = new Modal({
                title: title,
                content: news.text,
                backdrop: 'static',
                headerClose: false,
                footer: news.cta,
                keyboard: false
            });

            $(myModal[index].el).find('button').attr('data-index', index);

            myModal[index].on('hide', function(thisModal) {
                let modal = $(thisModal.el);
                let newsId = modal.find('button').attr('data-news-id');
                let index = parseInt(modal.find('button').attr('data-index'));
                confirm(newsId);
                showModal(index + 1);
            });


        });
        showModal(0);
    });
}

/**
 * Show the given news box
 *  It will check if the modal for the given index is available
 * @param index
 */
function showModal(index) {
    if (index in myModal) {
        myModal[index].show();
    }
}

/**
 * Set the given news as confirmed
 *
 * @param newsId Id of news
 */
function confirm(newsId) {
    let url = window.config.urls.news.confirm.replace(':news:', newsId);
    window.axios.get(url).then(() => {});
}
